import PropTypes from 'prop-types'
import { PropTypes as MobXPropTypes } from 'mobx-react'
import React, { Component } from 'react'

import { halfCollection, createIndexCollection } from '../utils'

export default class ColumnList extends Component {

  static propTypes = {
    auth: PropTypes.object,
    className: PropTypes.string,
    currentUserMuseum: PropTypes.object,
    isMuseum: PropTypes.bool,
    keyString: PropTypes.string,
    list: MobXPropTypes.observableArray,
    renderEntry: PropTypes.func
  }

  renderIndexListEntry(item) {

    const { currentUserMuseum, isMuseum } = this.props

    if (typeof item === 'string') {
      return (
        <li
          key={item.id}
          className="label"
        >
          <span
            className="index"
            id={item.toUpperCase()}
          >
            {item}
          </span>
        </li>
      )
    }

    return this.props.renderEntry({
      editable: (isMuseum ? item.versionRefId : item.museum.id) === currentUserMuseum,
      key: item.id,
      entry: item
    })

  }

  render() {

    const {
      list, keyString, className, isMuseum
    } = this.props

    const createIndexCollectionOpts = {
      lastChar: ' ',
      key: keyString
    }

    const collection = list
      // only show items that have a sanitizedOrder*
      .filter((currItem) => !!currItem[keyString])
      // only show items that have a version
      .filter((currItem) => !!currItem.versionRefId)
      // only show items that belong to a museum (in case of programs/tours)
      .filter((currItem) => {
        if (!isMuseum && !currItem.museum) {
          // console.warn(`Invalid program ${currItem.id}: Museum missing!`)
          return false
        }
        return true
      })

    if (!collection.length) {
      return <div>Keine Daten</div>
    }

    const [collection1, collection2] = halfCollection(
      collection,
      keyString
    )

    return (
      <div
        className={`${className} index-list`}
      >

        <ul
          className="nav-list vertical"
        >
          {
            createIndexCollection(collection1, createIndexCollectionOpts)
              .map((currItem) => this.renderIndexListEntry(currItem))
          }
        </ul>

        <ul
          className="nav-list vertical"
        >
          {
            createIndexCollection(collection2, createIndexCollectionOpts)
              .map((currItem) => this.renderIndexListEntry(currItem))
          }
        </ul>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ColumnList.js